export const menuTheme = {
  colorScheme: {
    light: {
      root: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        borderRadius: '{content.border.radius}',
        color: '{gray.900}',
        shadow: '{shadow.level2}'
      },
      list: {
        padding: '0.25rem 0',
        gap: '0.25rem 0'
      },
      item: {
        color: '{gray.900}',
        focusBackground: 'var(--text-bg-hover)',
        focusColor: '{gray.900}',
        padding: '0.5rem 1rem',
        borderRadius: '{content.border.radius}',
        gap: '0.5rem',
        icon: {
          color: 'rgba(0, 0, 0, 0.6)',
          focusColor: 'rgba(0, 0, 0, 0.6)'
        }
      },
      separator: {
        borderColor: '{surface.border}'
      },
      submenuLabel: {
        padding: '0.5rem 1rem',
        fontWeight: '600',
        background: '{content.background}',
        color: '{gray.900}'
      }
    },
    dark: {
      root: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        borderRadius: '{content.border.radius}',
        color: '{gray.0}',
        shadow: '{shadow.level2}'
      },
      list: {
        padding: '0.25rem 0',
        gap: '0.25rem 0'
      },
      item: {
        color: '{gray.0}',
        focusBackground: 'var(--text-bg-hover-2)',
        focusColor: '{gray.0}',
        padding: '0.5rem 1rem',
        borderRadius: '{content.border.radius}',
        gap: '0.5rem',
        icon: {
          color: 'rgba(255, 255, 255, 0.8)',
          focusColor: 'rgba(255, 255, 255, 0.8)'
        }
      },
      separator: {
        borderColor: '{surface.border}'
      },
      submenuLabel: {
        padding: '0.5rem 1rem',
        fontWeight: '600',
        background: '{content.background}',
        color: '{gray.0}'
      }
    }
  },
  css: ({ dt }: { dt: any }) => `
    /* Mogenius Menu Base Styles */
    [data-bs-theme='dark'] .p-menu-item-link:hover {
      color: ${dt('gray.0')} !important;
    }
  `
};
